<template>
  <div class="w-100">
    Invoice marked as UNPAID for

    <span class="mr-1">
      <invoice-object
        :entity-id="invoiceId()"
        :invoice="$lodash.get(activity, 'detail.invoice')"
        :open-new="true"
      />
    </span>
  </div>
</template>

<script type="text/babel">
import BaseComponent from "./BaseComponent.vue";

export default {
  extends: BaseComponent,
};
</script>
